<template>
  <header id="header">
    <b-navbar toggleable="lg">
      <b-navbar-brand href="/">
        <img class="logo ml-2" alt="logo" src="@/assets/logo-nombre-morado.png" height="50" width="90"/>
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="ml-auto">
          <template v-if="authenticated">
            <b-nav-item :to="{ path: '/licitaciones/buscar' }">
              <i class="fas fa-search"></i>
              <p class="m-0 text-menu">Buscar</p>
            </b-nav-item>
            <b-nav-item :to="{ path: '/licitaciones/notificaciones' }">
              <i :class="currentPath==='/licitaciones/notificaciones'?'fas fa-flag':'far fa-flag'"></i>
              <p class="m-0 text-menu">Notificaciones </p>
              <b-badge class="rounded-pill counter">
              <span v-if="total_notifications > 1000"> +1000</span><span v-else>{{total_notifications}}</span></b-badge>
            </b-nav-item>
            <b-nav-item :to="{ path: '/licitaciones/alertas' }">
              <i :class="currentPath==='/licitaciones/alertas'?'fas fa-bell':'far fa-bell'"></i>
                <p class="m-0 text-menu">Alertas</p>   
            </b-nav-item>
            <b-nav-item  :to="{ path: '/licitaciones/favoritas' }">
              <i :class="currentPath==='/licitaciones/favoritas'?'fas fa-star':'far fa-star'"></i>
              <p class="m-0 text-menu">Favoritas</p>
            </b-nav-item>
            <b-nav-item  :to="{ path: '/licitaciones/mis_empresas' }">
              <i :class="currentPath==='/licitaciones/mis_empresas'?'fas fa-building':'far fa-building'"></i>
                <p class="m-0 text-menu">Empresas</p>
            </b-nav-item>
              <b-nav-item :class="administrator?'main-item dropdown': 'main-item dropdown extra-margin'" v-on-clickaway="clickAwayAccountDropdown">
                <a class="dropdown-toggle m-2 " id="userDropdown" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false" @click="toggleDropdown">  
                <span class="user-badge rounded-circle px-3 py-2">{{firstLetter}}</span>
                </a>
                <div class="dropdown-menu dropdown-default" :class="{ show: showDropdown }" aria-labelledby="userDropdown">
                  <router-link to="/user" class="dropdown-item" v-on:click.native="toggleDropdown"> Cuenta </router-link>
                  <router-link to="/subscription" class="dropdown-item" v-on:click.native="toggleDropdown">Suscripción</router-link> 
                  <a href="#" v-on:click="clickSignOut" class="dropdown-item">{{ $t('signOut') }}</a>
                </div>
              </b-nav-item>
          </template>
          <template v-else>          
            <b-nav-item class="nav-item">
            <router-link to="/sign_in" class="nav-link menu-item"><span class="text-sign-out">{{ $t('signIn') }}</span></router-link>
          </b-nav-item>
          <b-nav-item class="nav-item">
            <router-link to="/contacto" class="nav-link menu-item"><span class="text-sign-out">Contacto</span></router-link>
          </b-nav-item>
          </template>
          <template v-if="authenticated && administrator">
          <b-nav-item class="main-item dropdown" v-on-clickaway="clickAwayAdminDropdown">
            <a class="dropdown-toggle " id="adminDropdown" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false" @click="toggleAdminDropdown"> 
              Admin
            </a>
                <div class="dropdown-menu dropdown-default" :class="{ show: showAdminDropdown }" aria-labelledby="adminDropdown">
                  <router-link to="/admin/users" class="dropdown-item"> {{ $t('users') }} </router-link>
                  <a class="dropdown-item" :href="sidekiqUrl" target="_blank"> Sidekiq </a>
                </div>
              </b-nav-item>
          </template>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </header>
</template>

<script>

import { mapActions, mapGetters, mapState } from 'vuex';
import { mixin as clickaway } from 'vue-clickaway';

export default {
  mixins: [clickaway],
  data() {
    return {
      showDropdown: false,
      showAdminDropdown: false,
      showHelpDropdown: false,
    };
  },
  computed: {
    ...mapGetters('usersModule', ['user']),
    authenticated() {
      return this.$auth.check();
    },
    ...mapState({
      total_notifications: state => state.procurementNotificationsModule.total_results,
    }),
    administrator() {
      return this.$auth.check(['admin']);
    },
    sidekiqUrl() {
      return `${process.env.VUE_APP_API_BASE_URL}/sidekiq`;
    },
    firstLetter() {
      return this.user && this.user.name ? this.user.name.charAt(0).toUpperCase() : '';
    },
    currentPath() {
      return this.$route.path;
    },
  },
  methods: {
    ...mapActions('usersModule', ['signOut']),

    clickSignOut() {
      this.$auth.logout();
      this.showDropdown = false;
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    toggleAdminDropdown() {
      this.showAdminDropdown = !this.showAdminDropdown;
    },
    clickAwayAccountDropdown() {
      this.showDropdown = false;
    },
    clickAwayAdminDropdown() {
      this.showAdminDropdown = false;
    },
    clickAwayHelpDropdown() {
      this.showHelpDropdown = false;
    },
  },
};
</script>

<style scoped>
.logo{
  height: 50px;
}
.navbar{
  box-shadow: 0 0 10px #4953CF;
  margin-bottom: 10px;
  background: white;
  z-index: 1000;
  font-size:1.3em;
}
.fa-star{
  font-size: 1em;
}
.counter{
    position: absolute;
    top: 4px;
    font-size: 0.7em;
    padding: 2px 7px;
    color: white !important;
    background-color: #8F8EF8;
      @media(max-width: 768px) {
        display: none;
      }
  }
  .nav-link:hover, .dropdown-item:focus {
    background-color:  #E5E5E5 !important;
  }
.nav-link > i {
  color: #3d3d3d;
  height: 100% !important;
}
.dropdown-toggle, .dropdown-toggle:hover, .dropdown-item:hover {
  color: #3d3d3d !important;
  text-decoration: none;
}
.router-link-active > p,   .router-link-active > i{
  color:#8F8EF8;
}
.dropdown-toggle{
  font-size: 0.8em;
}
.text-menu{
  color: #3d3d3d;
  font-size: 0.6em;
}
.dropdown{
  padding-top: 5px;
}
.extra-margin{
  margin-right: 50px;
}
.user-badge{
  background-color: #8F8EF8 
}
.text-sign-out{
  font-size: 0.8em;
  color: #4953CF !important;
  

}
a{
text-decoration: none !important;
}
  /*
.main-item > a:hover {
  background-color: #E5E5E5 !important;
  color: #8F8EF8 !important;
  text-decoration: underline;
}*/
</style>
